import { useCallback, useEffect } from "react";
import { useRecoilState } from "recoil";
import { breakpoints, responsiveState } from "../states/UtilStates";

const ResponsiveMeasurer = ({ size }) => {
	const [breakpointState, setBreakpointState] = useRecoilState(responsiveState(size));

	const checkWidth = useCallback(() => {
		const isSmaller = window.innerWidth < breakpoints[size];
		if (breakpointState !== isSmaller) {
			setBreakpointState(isSmaller);
		}
	}, [setBreakpointState, size, breakpointState]);

	useEffect(() => {
		if (typeof window !== "undefined") {
			window.addEventListener("resize", checkWidth);
			checkWidth();
		}

		return () => {
			if (typeof window !== "undefined") {
				window.removeEventListener("resize", checkWidth);
			}
		};
	}, [checkWidth]);

	return null;
};

const ResponsiveController = ({ children }) => {
	return (
		<>
			{Object.keys(breakpoints).map((size) => (
				<ResponsiveMeasurer
					{...{
						key: size,
						size,
					}}
				/>
			))}
			{children}
		</>
	);
};

export default ResponsiveController;
